import React, { useEffect } from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaInstagram,
} from "react-icons/fa";
import { BiSolidLike } from "react-icons/bi";
import "./Contact.scss";
import ContactForm from "../../components/ContactForm/ContactForm";
import AOS from "aos";
import "aos/dist/aos.css";

const Contact = ({isRemplacement = false}) => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 300,
      once: true,
    });
  }, []);

  return (
    <section id="contact" className="contact-section">
      <div
        data-aos="zoom-in"
        data-aos-offset="300"
        className="contact-intro section-container"
      >
        <h2 className="title">Contactez-moi</h2>
        <div className="text-content">
          
          {isRemplacement === true ? (
            <div className="text-content espace">
              <p>
                En tant que professionnelle du remplacement en élevage et en
                pension, j’apporte mon <strong>expertise</strong> et mon <strong>engagement</strong> pour assurer
                la continuité et le bon fonctionnement de votre structure en
                votre absence. Forte d’une <strong>solide expérience</strong> dans le soin aux
                animaux, la gestion quotidienne et le respect des protocoles
                d’élevage et de pension, je m’adapte à vos besoins spécifiques
                pour <strong>garantir le bien-être de vos animaux</strong> et la <strong>performance de
                votre établissement</strong>.
              </p>

              <p>
                Que ce soit pour un remplacement ponctuel, une absence prolongée
                ou un soutien lors des périodes de forte activité, je suis à
                votre disposition pour assurer une <strong>transition fluide et
                efficace</strong>.
              </p>

              <p>
                N’hésitez pas à me contacter via les informations ci-dessous ou
                en remplissant le formulaire pour échanger sur vos besoins et
                organiser une intervention adaptée à votre exploitation ou
                pension.
              </p>
            </div>
          ) : (
            <p>
            En tant qu'éducatrice comportementaliste canin et félin et en tant
            qu'<strong>humaine</strong>, je suis animé par une profonde passion
            pour les animaux ainsi que leurs bien-être. Vous pouvez utiliser les
            informations ci-dessous ou le formulaire pour me contacter et
            échanger sur vos besoins.
          </p>
          )}
        </div>
      </div>

      <div className="contact-body">
        <div className="contact-info">
          <div className="info-box">
            <div>
              <FaMapMarkerAlt />
              <h3>Zone d'intervention</h3>
              Toute la France
              <iframe
                title="map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d85460.5255736404!2d0.11330008699806607!3d47.98198999261094!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8b13ca5657e49eb1%3A0x8731156d33c16924!2sPok%C3%A9lu%20-%20Rempla%C3%A7ante%20d&#39;%C3%A9levage%2Fpension%20canin%20et%20f%C3%A9lin!5e0!3m2!1sfr!2sfr!4v1738312787734!5m2!1sfr!2sfr"
                height="150"
                width="150"
                loading="lazy"
                className="map"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
          <div className="info-box">
            <div>
              <FaPhoneAlt />
              <h3>Téléphone</h3>
              <a href="tel:+0615905661">+33 6 15 90 56 61</a>
            </div>
          </div>
          <div className="info-box">
            <div>
              <FaEnvelope />
              <h3>Email</h3>
              <a href="mailto:pokelu.educ@gmail.com">pokelu.educ@gmail.com</a>
            </div>
          </div>
          <div className="info-box">
            <div>
              <BiSolidLike />
              <h3>Réseaux sociaux</h3>
              <a
                href="https://www.instagram.com/pokelu.educ/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link instagram"
              >
                <FaInstagram style={{ verticalAlign: "middle" }} /> Instagram
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61572549170099"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link facebook"
              >
                <FaFacebookF style={{ verticalAlign: "middle" }} /> Facebook
              </a>
            </div>
          </div>
        </div>

        <div className="contact-form">
          <ContactForm />
        </div>
      </div>
    </section>
  );
};

export default Contact;
